var map = {
	"./views/404": [
		75971,
		5971
	],
	"./views/404.vue": [
		75971,
		5971
	],
	"./views/AboutView": [
		55609,
		5609
	],
	"./views/AboutView.vue": [
		55609,
		5609
	],
	"./views/Billing": [
		19344,
		9344
	],
	"./views/Billing copy": [
		44019,
		4019
	],
	"./views/Billing copy.vue": [
		44019,
		4019
	],
	"./views/Billing.vue": [
		19344,
		9344
	],
	"./views/Dashboard": [
		2522,
		2522
	],
	"./views/Dashboard.vue": [
		2522,
		2522
	],
	"./views/HomeView": [
		55515,
		5515
	],
	"./views/HomeView.vue": [
		55515,
		5515
	],
	"./views/Layout": [
		40637,
		637
	],
	"./views/Layout.vue": [
		40637,
		637
	],
	"./views/Profile": [
		12436,
		2436
	],
	"./views/Profile.vue": [
		12436,
		2436
	],
	"./views/RTL": [
		39327,
		9327
	],
	"./views/RTL.vue": [
		39327,
		9327
	],
	"./views/Tables": [
		2422,
		2422
	],
	"./views/Tables.vue": [
		2422,
		2422
	],
	"./views/admin/banner/BannerCreate": [
		14126,
		1634,
		9047
	],
	"./views/admin/banner/BannerCreate.vue": [
		14126,
		1634,
		9047
	],
	"./views/admin/banner/BannerEdit": [
		79376,
		9376
	],
	"./views/admin/banner/BannerEdit.vue": [
		79376,
		9376
	],
	"./views/admin/banner/BannerList": [
		92706,
		4292,
		775
	],
	"./views/admin/banner/BannerList.vue": [
		92706,
		4292,
		775
	],
	"./views/admin/banner/BannerView": [
		10154,
		154
	],
	"./views/admin/banner/BannerView.vue": [
		10154,
		154
	],
	"./views/admin/blog/BlogCreate": [
		91594,
		1634,
		4289,
		7204
	],
	"./views/admin/blog/BlogCreate.vue": [
		91594,
		1634,
		4289,
		7204
	],
	"./views/admin/blog/BlogEdit": [
		4314,
		1634,
		4289,
		1780
	],
	"./views/admin/blog/BlogEdit.vue": [
		4314,
		1634,
		4289,
		1780
	],
	"./views/admin/blog/BlogList": [
		28086,
		4292,
		3467
	],
	"./views/admin/blog/BlogList.vue": [
		28086,
		4292,
		3467
	],
	"./views/admin/blog/BlogView": [
		77849,
		7849
	],
	"./views/admin/blog/BlogView.vue": [
		77849,
		7849
	],
	"./views/admin/categories/CategoriesCreate": [
		93806,
		1634,
		6807
	],
	"./views/admin/categories/CategoriesCreate.vue": [
		93806,
		1634,
		6807
	],
	"./views/admin/categories/CategoriesEdit": [
		40846,
		1634,
		1207
	],
	"./views/admin/categories/CategoriesEdit.vue": [
		40846,
		1634,
		1207
	],
	"./views/admin/categories/CategoriesList": [
		56130,
		4292,
		8023
	],
	"./views/admin/categories/CategoriesList.vue": [
		56130,
		4292,
		8023
	],
	"./views/admin/categories/CategoriesView": [
		8155,
		8155
	],
	"./views/admin/categories/CategoriesView.vue": [
		8155,
		8155
	],
	"./views/admin/customer/Customer": [
		27254,
		2572,
		5353,
		2037
	],
	"./views/admin/customer/Customer.vue": [
		27254,
		2572,
		5353,
		2037
	],
	"./views/admin/customer/component/CustomerCreate": [
		73458,
		2572,
		731
	],
	"./views/admin/customer/component/CustomerCreate.vue": [
		73458,
		2572,
		731
	],
	"./views/admin/customer/component/CustomerCreateForm": [
		82572,
		2572,
		9016
	],
	"./views/admin/customer/component/CustomerCreateForm.vue": [
		82572,
		2572,
		9016
	],
	"./views/admin/customer/component/ServiceBuy": [
		45353,
		2572,
		5353,
		4001
	],
	"./views/admin/customer/component/ServiceBuy.vue": [
		45353,
		2572,
		5353,
		4001
	],
	"./views/admin/customer/component/ServiceHostingList": [
		94399,
		2572,
		5353,
		3896
	],
	"./views/admin/customer/component/ServiceHostingList.vue": [
		94399,
		2572,
		5353,
		3896
	],
	"./views/admin/dasboard/Dasboard": [
		51151,
		1151
	],
	"./views/admin/dasboard/Dasboard.vue": [
		51151,
		1151
	],
	"./views/admin/expenditure/Expenditure": [
		84566,
		4292,
		8289
	],
	"./views/admin/expenditure/Expenditure.vue": [
		84566,
		4292,
		8289
	],
	"./views/admin/expenditure/component/ChangePassword": [
		32393,
		2393
	],
	"./views/admin/expenditure/component/ChangePassword.vue": [
		32393,
		2393
	],
	"./views/admin/expenditure/component/CreateUser": [
		42623,
		2623
	],
	"./views/admin/expenditure/component/CreateUser.vue": [
		42623,
		2623
	],
	"./views/admin/expenditure/component/EditUser": [
		19560,
		9560
	],
	"./views/admin/expenditure/component/EditUser.vue": [
		19560,
		9560
	],
	"./views/admin/faq/FaqCreate": [
		72445,
		2445
	],
	"./views/admin/faq/FaqCreate.vue": [
		72445,
		2445
	],
	"./views/admin/faq/FaqEdit": [
		2858,
		2858
	],
	"./views/admin/faq/FaqEdit.vue": [
		2858,
		2858
	],
	"./views/admin/faq/FaqList": [
		60376,
		4292,
		217
	],
	"./views/admin/faq/FaqList.vue": [
		60376,
		4292,
		217
	],
	"./views/admin/faq/FaqView": [
		73694,
		3694
	],
	"./views/admin/faq/FaqView.vue": [
		73694,
		3694
	],
	"./views/admin/news/NewsCreate": [
		46340,
		1634,
		4289,
		6786
	],
	"./views/admin/news/NewsCreate.vue": [
		46340,
		1634,
		4289,
		6786
	],
	"./views/admin/news/NewsEdit": [
		57740,
		1634,
		4289,
		3562
	],
	"./views/admin/news/NewsEdit.vue": [
		57740,
		1634,
		4289,
		3562
	],
	"./views/admin/news/NewsList": [
		25684,
		4292,
		8821
	],
	"./views/admin/news/NewsList.vue": [
		25684,
		4292,
		8821
	],
	"./views/admin/news/NewsView": [
		25299,
		5299
	],
	"./views/admin/news/NewsView.vue": [
		25299,
		5299
	],
	"./views/admin/product/ColorForm": [
		65958,
		5958
	],
	"./views/admin/product/ColorForm.vue": [
		65958,
		5958
	],
	"./views/admin/product/ProductCreate": [
		820,
		1634,
		4289,
		2539,
		2994
	],
	"./views/admin/product/ProductCreate.vue": [
		820,
		1634,
		4289,
		2539,
		2994
	],
	"./views/admin/product/ProductEdit": [
		29308,
		1634,
		4289,
		2539,
		8682
	],
	"./views/admin/product/ProductEdit.vue": [
		29308,
		1634,
		4289,
		2539,
		8682
	],
	"./views/admin/product/ProductList": [
		97924,
		4292,
		8085
	],
	"./views/admin/product/ProductList.vue": [
		97924,
		4292,
		8085
	],
	"./views/admin/product/ProductView": [
		56768,
		6768
	],
	"./views/admin/product/ProductView.vue": [
		56768,
		6768
	],
	"./views/admin/product/component/Attributes": [
		28539,
		8539
	],
	"./views/admin/product/component/Attributes.vue": [
		28539,
		8539
	],
	"./views/admin/product/component/Create": [
		62539,
		4289,
		2539,
		3242
	],
	"./views/admin/product/component/Create.vue": [
		62539,
		4289,
		2539,
		3242
	],
	"./views/admin/product/component/Images": [
		86733,
		1634,
		2338
	],
	"./views/admin/product/component/Images.vue": [
		86733,
		1634,
		2338
	],
	"./views/admin/product/component/ImagesList": [
		73501,
		3501
	],
	"./views/admin/product/component/ImagesList.vue": [
		73501,
		3501
	],
	"./views/admin/product/component/Variant": [
		50867,
		867
	],
	"./views/admin/product/component/Variant.vue": [
		50867,
		867
	],
	"./views/admin/product/support/Variant": [
		91917,
		1917
	],
	"./views/admin/product/support/Variant.vue": [
		91917,
		1917
	],
	"./views/admin/revenue/Revenue": [
		40620,
		4292,
		2442
	],
	"./views/admin/revenue/Revenue.vue": [
		40620,
		4292,
		2442
	],
	"./views/admin/revenue/component/ChangePassword": [
		47064,
		7064
	],
	"./views/admin/revenue/component/ChangePassword.vue": [
		47064,
		7064
	],
	"./views/admin/revenue/component/CreateUser": [
		76621,
		6621
	],
	"./views/admin/revenue/component/CreateUser.vue": [
		76621,
		6621
	],
	"./views/admin/revenue/component/EditUser": [
		81717,
		1717
	],
	"./views/admin/revenue/component/EditUser.vue": [
		81717,
		1717
	],
	"./views/admin/user/UserInform": [
		30014,
		14
	],
	"./views/admin/user/UserInform.vue": [
		30014,
		14
	],
	"./views/admin/user/UserList": [
		76520,
		4292,
		1433
	],
	"./views/admin/user/UserList.vue": [
		76520,
		4292,
		1433
	],
	"./views/admin/user/component/ChangePassword": [
		34422,
		4422
	],
	"./views/admin/user/component/ChangePassword.vue": [
		34422,
		4422
	],
	"./views/admin/user/component/CreateUser": [
		67233,
		7233
	],
	"./views/admin/user/component/CreateUser.vue": [
		67233,
		7233
	],
	"./views/admin/user/component/EditUser": [
		10277,
		277
	],
	"./views/admin/user/component/EditUser.vue": [
		10277,
		277
	],
	"./views/client/about/About": [
		87743,
		7743
	],
	"./views/client/about/About.vue": [
		87743,
		7743
	],
	"./views/client/blog/Blog": [
		70950,
		950
	],
	"./views/client/blog/Blog.vue": [
		70950,
		950
	],
	"./views/client/cart/Cart": [
		87001,
		7001
	],
	"./views/client/cart/Cart.vue": [
		87001,
		7001
	],
	"./views/client/cart/CartMenu": [
		38150
	],
	"./views/client/cart/CartMenu.vue": [
		38150
	],
	"./views/client/cart/CartSubmit": [
		59404,
		9404
	],
	"./views/client/cart/CartSubmit.vue": [
		59404,
		9404
	],
	"./views/client/cart/CartSupport": [
		52817,
		2817
	],
	"./views/client/cart/CartSupport.vue": [
		52817,
		2817
	],
	"./views/client/collections/Collections": [
		6702,
		6702
	],
	"./views/client/collections/Collections.vue": [
		6702,
		6702
	],
	"./views/client/collections/CollectionsItems": [
		84448,
		4448
	],
	"./views/client/collections/CollectionsItems.vue": [
		84448,
		4448
	],
	"./views/client/collections/Collections_page": [
		26536,
		6536
	],
	"./views/client/collections/Collections_page.vue": [
		26536,
		6536
	],
	"./views/client/collections/HomeCollection": [
		31962,
		1962
	],
	"./views/client/collections/HomeCollection.vue": [
		31962,
		1962
	],
	"./views/client/contact/Contact": [
		60286,
		286
	],
	"./views/client/contact/Contact.vue": [
		60286,
		286
	],
	"./views/client/contact/Maps": [
		66250,
		6250
	],
	"./views/client/contact/Maps.vue": [
		66250,
		6250
	],
	"./views/client/customer/ReturnContruction": [
		2839,
		2839
	],
	"./views/client/customer/ReturnContruction.vue": [
		2839,
		2839
	],
	"./views/client/customer/ReturnPolicy": [
		88506,
		8506
	],
	"./views/client/customer/ReturnPolicy.vue": [
		88506,
		8506
	],
	"./views/client/customer/ShippingPolicy": [
		17210,
		7210
	],
	"./views/client/customer/ShippingPolicy.vue": [
		17210,
		7210
	],
	"./views/client/customer/WarranPolicy": [
		26204,
		6204
	],
	"./views/client/customer/WarranPolicy.vue": [
		26204,
		6204
	],
	"./views/client/faq/Faq": [
		80058,
		58
	],
	"./views/client/faq/Faq.vue": [
		80058,
		58
	],
	"./views/client/favourite/Favourite": [
		58934,
		61,
		1772
	],
	"./views/client/favourite/Favourite.vue": [
		58934,
		61,
		1772
	],
	"./views/client/google/GoogleMap": [
		4375,
		4375
	],
	"./views/client/google/GoogleMap.vue": [
		4375,
		4375
	],
	"./views/client/home/BannerSloganSeller": [
		23724,
		8834
	],
	"./views/client/home/BannerSloganSeller.vue": [
		23724,
		8834
	],
	"./views/client/home/CategoryBanner": [
		26853,
		6853
	],
	"./views/client/home/CategoryBanner.vue": [
		26853,
		6853
	],
	"./views/client/home/Home": [
		2078,
		61,
		8308
	],
	"./views/client/home/Home.vue": [
		2078,
		61,
		8308
	],
	"./views/client/home/child/FeaturedProducts": [
		70104,
		61,
		2882
	],
	"./views/client/home/child/FeaturedProducts.vue": [
		70104,
		61,
		2882
	],
	"./views/client/home/slide/CategoryHome": [
		68464,
		8464
	],
	"./views/client/home/slide/CategoryHome.vue": [
		68464,
		8464
	],
	"./views/client/introduction/AboutMe": [
		22384,
		2384
	],
	"./views/client/introduction/AboutMe.vue": [
		22384,
		2384
	],
	"./views/client/introduction/Addresses": [
		13249,
		3249
	],
	"./views/client/introduction/Addresses.vue": [
		13249,
		3249
	],
	"./views/client/introduction/Careers": [
		51928,
		1928
	],
	"./views/client/introduction/Careers.vue": [
		51928,
		1928
	],
	"./views/client/introduction/ContactUs": [
		37177,
		7177
	],
	"./views/client/introduction/ContactUs.vue": [
		37177,
		7177
	],
	"./views/client/introduction/OurCommitment": [
		63266,
		3266
	],
	"./views/client/introduction/OurCommitment.vue": [
		63266,
		3266
	],
	"./views/client/introduction/PaymentMethod": [
		28593,
		8593
	],
	"./views/client/introduction/PaymentMethod.vue": [
		28593,
		8593
	],
	"./views/client/introduction/ProfileInfo": [
		80756,
		756
	],
	"./views/client/introduction/ProfileInfo.vue": [
		80756,
		756
	],
	"./views/client/introduction/StoreLocation": [
		17252,
		7252
	],
	"./views/client/introduction/StoreLocation.vue": [
		17252,
		7252
	],
	"./views/client/login/lock/LockScreen": [
		20987,
		987
	],
	"./views/client/login/lock/LockScreen.vue": [
		20987,
		987
	],
	"./views/client/login/password/ForgotPassword": [
		42116,
		2116
	],
	"./views/client/login/password/ForgotPassword.vue": [
		42116,
		2116
	],
	"./views/client/login/signin/Login": [
		56167,
		6167
	],
	"./views/client/login/signin/Login copy": [
		27822,
		7822
	],
	"./views/client/login/signin/Login copy.vue": [
		27822,
		7822
	],
	"./views/client/login/signin/Login.vue": [
		56167,
		6167
	],
	"./views/client/login/signin/component/FacebookLogin": [
		41441,
		1441
	],
	"./views/client/login/signin/component/FacebookLogin.vue": [
		41441,
		1441
	],
	"./views/client/login/signin/component/GoogleLogin": [
		3585,
		3585
	],
	"./views/client/login/signin/component/GoogleLogin.vue": [
		3585,
		3585
	],
	"./views/client/login/signin/login.css": [
		50054,
		54
	],
	"./views/client/login/signup/FaceBookRegister": [
		53024,
		3024
	],
	"./views/client/login/signup/FaceBookRegister.vue": [
		53024,
		3024
	],
	"./views/client/login/signup/GoogleRegister": [
		20730,
		730
	],
	"./views/client/login/signup/GoogleRegister.vue": [
		20730,
		730
	],
	"./views/client/login/signup/RegisterForm": [
		13968,
		3968
	],
	"./views/client/login/signup/RegisterForm copy": [
		84750,
		4750
	],
	"./views/client/login/signup/RegisterForm copy.vue": [
		84750,
		4750
	],
	"./views/client/login/signup/RegisterForm.vue": [
		13968,
		3968
	],
	"./views/client/login/signup/TelegramRegister": [
		72357,
		2357
	],
	"./views/client/login/signup/TelegramRegister.vue": [
		72357,
		2357
	],
	"./views/client/news/News": [
		42230,
		2230
	],
	"./views/client/news/News.vue": [
		42230,
		2230
	],
	"./views/client/news/NewsDetails": [
		25704,
		5704
	],
	"./views/client/news/NewsDetails.vue": [
		25704,
		5704
	],
	"./views/client/news/NewsICategory": [
		25142,
		5142
	],
	"./views/client/news/NewsICategory.vue": [
		25142,
		5142
	],
	"./views/client/news/NewsItem": [
		79564,
		9564
	],
	"./views/client/news/NewsItem.vue": [
		79564,
		9564
	],
	"./views/client/news/NewsTop3": [
		54446,
		4446
	],
	"./views/client/news/NewsTop3.vue": [
		54446,
		4446
	],
	"./views/client/news/TopView": [
		70684,
		8303
	],
	"./views/client/news/TopView.vue": [
		70684,
		8303
	],
	"./views/client/orders/AllOrder": [
		28747,
		8747
	],
	"./views/client/orders/AllOrder.vue": [
		28747,
		8747
	],
	"./views/client/orders/AwaitingDelivery": [
		33332,
		3332
	],
	"./views/client/orders/AwaitingDelivery.vue": [
		33332,
		3332
	],
	"./views/client/orders/AwaitingShipment": [
		51779,
		1779
	],
	"./views/client/orders/AwaitingShipment.vue": [
		51779,
		1779
	],
	"./views/client/orders/Orders": [
		95110,
		5110
	],
	"./views/client/orders/Orders.vue": [
		95110,
		5110
	],
	"./views/client/orders/PendingPayment": [
		40629,
		629
	],
	"./views/client/orders/PendingPayment.vue": [
		40629,
		629
	],
	"./views/client/orders/Purchases": [
		73387,
		3387
	],
	"./views/client/orders/Purchases.vue": [
		73387,
		3387
	],
	"./views/client/orders/component/Address": [
		82907,
		2907
	],
	"./views/client/orders/component/Address.vue": [
		82907,
		2907
	],
	"./views/client/orders/component/Information": [
		35992,
		5992
	],
	"./views/client/orders/component/Information.vue": [
		35992,
		5992
	],
	"./views/client/orders/component/OrderInformation": [
		56364,
		6364
	],
	"./views/client/orders/component/OrderInformation.vue": [
		56364,
		6364
	],
	"./views/client/orders/component/OrderItems": [
		40642,
		642
	],
	"./views/client/orders/component/OrderItems.vue": [
		40642,
		642
	],
	"./views/client/orders/component/Shipping": [
		83926,
		3926
	],
	"./views/client/orders/component/Shipping.vue": [
		83926,
		3926
	],
	"./views/client/portfolio/Portfolio": [
		6050,
		6050
	],
	"./views/client/portfolio/Portfolio.vue": [
		6050,
		6050
	],
	"./views/client/portfolio/PortfolioItems": [
		7803,
		7803
	],
	"./views/client/portfolio/PortfolioItems.vue": [
		7803,
		7803
	],
	"./views/client/pricing/Pricing": [
		69022,
		9022
	],
	"./views/client/pricing/Pricing.vue": [
		69022,
		9022
	],
	"./views/client/product/ProductDetails": [
		45048,
		61,
		8754
	],
	"./views/client/product/ProductDetails.vue": [
		45048,
		61,
		8754
	],
	"./views/client/product/ProductList": [
		6382,
		6382
	],
	"./views/client/product/ProductList.vue": [
		6382,
		6382
	],
	"./views/client/product/Products": [
		93369,
		61,
		6529
	],
	"./views/client/product/Products.vue": [
		93369,
		61,
		6529
	],
	"./views/client/product/Search": [
		2213,
		61,
		5581
	],
	"./views/client/product/Search.vue": [
		2213,
		61,
		5581
	],
	"./views/client/product/common/DetailColor": [
		35400,
		5400
	],
	"./views/client/product/common/DetailColor.vue": [
		35400,
		5400
	],
	"./views/client/product/common/DetailGallery": [
		84564,
		4564
	],
	"./views/client/product/common/DetailGallery.vue": [
		84564,
		4564
	],
	"./views/client/product/common/DetailSize": [
		49025,
		9025
	],
	"./views/client/product/common/DetailSize.vue": [
		49025,
		9025
	],
	"./views/client/product/common/DetailStyle": [
		69978,
		9978
	],
	"./views/client/product/common/DetailStyle.vue": [
		69978,
		9978
	],
	"./views/client/product/common/HeaderCategory": [
		33230,
		3230
	],
	"./views/client/product/common/HeaderCategory.vue": [
		33230,
		3230
	],
	"./views/client/product/common/MarkPrice": [
		2245,
		2245
	],
	"./views/client/product/common/MarkPrice.vue": [
		2245,
		2245
	],
	"./views/client/product/common/ProductItems": [
		30061,
		61,
		3241
	],
	"./views/client/product/common/ProductItems.vue": [
		30061,
		61,
		3241
	],
	"./views/client/product/common/RelatedProducts": [
		75674,
		61,
		8400
	],
	"./views/client/product/common/RelatedProducts.vue": [
		75674,
		61,
		8400
	],
	"./views/client/product/common/SelectProduct": [
		24803,
		4803
	],
	"./views/client/product/common/SelectProduct.vue": [
		24803,
		4803
	],
	"./views/client/product/common/SlideProducts": [
		85340,
		5340
	],
	"./views/client/product/common/SlideProducts.vue": [
		85340,
		5340
	],
	"./views/client/product/common/ViewedProducts": [
		67185,
		61,
		6713
	],
	"./views/client/product/common/ViewedProducts.vue": [
		67185,
		61,
		6713
	],
	"./views/client/profile/Profile": [
		16452,
		6452
	],
	"./views/client/profile/Profile.vue": [
		16452,
		6452
	],
	"./views/client/service/Service": [
		12382,
		2382
	],
	"./views/client/service/Service.vue": [
		12382,
		2382
	],
	"./views/client/user/Profile": [
		46823,
		6823
	],
	"./views/client/user/Profile copy": [
		72342,
		2342
	],
	"./views/client/user/Profile copy.vue": [
		72342,
		2342
	],
	"./views/client/user/Profile.vue": [
		46823,
		6823
	],
	"./views/client/user/Profile2": [
		14463,
		4463
	],
	"./views/client/user/Profile2.vue": [
		14463,
		4463
	],
	"./views/client/user/inform/Information": [
		26327,
		6327
	],
	"./views/client/user/inform/Information.vue": [
		26327,
		6327
	],
	"./views/demo/KeycloakToken": [
		41265,
		1265
	],
	"./views/demo/KeycloakToken.vue": [
		41265,
		1265
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 55378;
module.exports = webpackAsyncContext;